import {
  Component, OnInit, ChangeDetectionStrategy, Input, Inject, ChangeDetectorRef,
  EventEmitter, Output
} from '@angular/core';
import { Observable } from 'rxjs';
import { set } from 'lodash';
import { get } from 'lodash';
import { DateHandler } from '../../../../../../shared/utils/DateHandler';
import { EnumService } from '@ispm/user/services/enum.service';

@Component({
  selector: 'gen-tumor-specimen',
  templateUrl: './tumor-specimen.component.html',
  styleUrls: ['./tumor-specimen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class TumorSpecimenComponent implements OnInit {
  public previousValue: any;
  @Input() sample: any;
  @Input() allowedit: boolean;
  @Input() disabledForced: boolean;
  @Input() updatedFields: string[];
  public collectionsData: any;
  private sampleObservable: Observable<any>;

  @Input('collections')
  set collections(specimen) {
    this.collectionsData = specimen ? specimen : { specimenTypes: []};
  }

  private selectedDatepicker: any;
  public selectedAutoComplete: any;
  tumorChanged: boolean;
  public ihcStatuses: any[];
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() index: number;

  constructor(private detector: ChangeDetectorRef, private enumService: EnumService) {
  }

  ngOnInit() {
  }


  compareBy(a: any, b: any) {
    return a && b ? a.code === b.code : a === b;
  }

  getIHCStatuses(event) {
    this.enumService.getIHCStatuses().subscribe((res) => {
      this.ihcStatuses = res.json().filter((status) => {
        return status.display.toLowerCase().contains(event.query.toLowerCase());
      });
      try {
        this.detector.detectChanges();
      } catch(err) {
        console.error('tumor-specimen component: ChangeDetectorRef was destroyed.');
      };
    });
  }

  public resetValue(name) {
    set(this.sample, name, this.previousValue);
  }

  modelChange($event, sample, field, required) {
    if (!required || (required && get(sample, field))) {
      this.callback.emit({ sample, field});
    }

    if ($event.target) {
      $event.target.dispatchEvent(new CustomEvent('deepBlur', { bubbles: true}));
    }
  }

  setTime(date: Date) {
    if (!(date instanceof Date)) { return; }
    date.setHours(12, 0);
    date.setTime(DateHandler.removeTimezone(date).getTime());

  }

  onDateSelect(sample, field) {
    this.callback.emit({sample, field});
    if (this.selectedDatepicker && this.selectedDatepicker !== null) {
      this.selectedDatepicker.focus();
      this.selectedDatepicker.blur();
    }
    this.selectedDatepicker = null;
  }

  onAutoFocus($event) {
    this.selectedAutoComplete = $event.target.closest('*[deep-blur]');
  }

  onFocus($event) {
    this.selectedDatepicker = $event.target.parentElement.parentElement;
  }

  isInUpdatedFields(field: string) {
    return this.updatedFields && this.updatedFields.indexOf(field) > -1;
  }

  trackByFn(item, index) {
      return item ? item.code : index;
  }


}
